// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"167e20d1","239":"e6310c6e","450":"59f8d31d","455":"9e5fd340","686":"ebf2a112","872":"e00046c5","884":"9eeeb8a9","977":"65e2637d"}[chunkId] + ".chunk.js";
};